import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { TestRequestService } from 'src/app/_services/test-request.service';

@Component({
  selector: 'app-upload-test-result',
  templateUrl: './upload-test-result.component.html',
  styleUrls: ['./upload-test-result.component.scss']
})
export class UploadTestResultComponent implements OnInit {
  pageTitle: string = 'Test Requests';

  imageFile;
  editMode = false;
  obj: { id, result };

  constructor(private testRequestService: TestRequestService,
    private activatedRoute: ActivatedRoute,
    public toastr: ToastrService,
    private router: Router) { }

  ngOnInit(): void {
    const id = this.activatedRoute.snapshot.params.serviceId;
  }

  onImageUpload(imageFile): void {
    this.imageFile = imageFile.target.files[0];
  }

  onAddLatestOffer(): void {
    this.obj = {
      id: this.activatedRoute.snapshot.params.reqId,
      result: this.imageFile
    }
    this.testRequestService
      .uploadTestResult(this.obj)
      .subscribe((res) => {
        showNotification(
          'success',
          `uploaded`,
          this.toastr
        );
        this.router.navigateByUrl('test-request');

      });
  }

}
